/**
 * 首页------------------------------------------
 * */
// 工作台
export const Dashboard = {
  path: "/dashboard",
  name: "dashboard",
  id: 1,
  component: () => import("@/page/dashboard/dashboard.vue")
};
/**
 * 客户管理------------------------------------------
 * */

// 客户列表
export const customUserlist = {
  path: "/customUserlist",
  name: "customUserlist",
  id: 1,
  component: () => import("@/page/custom/common/customUserlist.vue")
};
// 普通客户--客户列表
export const normalcustom = {
  path: "/normalcustom",
  name: "normalcustom",
  id: 1,
  component: () => import("@/page/custom/common/normalcustom.vue")
};
// 会员客户--客户列表
export const memberlist = {
  path: "/memberlist",
  name: "memberlist",
  id: 1,
  component: () => import("@/page/custom/member/memberlist.vue")
};
// 会员客户--我的客户
export const mymember = {
  path: "/mymember",
  name: "mymember",
  id: 1,
  component: () => import("@/page/custom/member/mymember.vue")
};
// 会员客户--我的跟进
export const myrecord = {
  path: "/myrecord",
  name: "myrecord",
  id: 1,
  component: () => import("@/page/custom/member/myrecord.vue")
};
// 会员客户--跟进记录
export const memberrecord = {
  path: "/memberrecord",
  name: "memberrecord",
  id: 1,
  component: () => import("@/page/custom/member/memberrecord.vue")
};
// 服务记录
export const servicerecord = {
  path: "/servicerecord",
  name: "servicerecord",
  id: 1,
  component: () => import("@/page/custom/member/servicerecord.vue")
};
// 我的服务记录
export const record = {
  path: "/record",
  name: "record",
  id: 1,
  component: () => import("@/page/service/record.vue")
};
// 陪跑客户--客户列表
export const customlist = {
  path: "/customlist",
  name: "customlist",
  id: 1,
  component: () => import("@/page/custom/common/customlist.vue")
};
// 陪跑客户--跟进记录
export const customrecord = {
  path: "/customrecord",
  name: "customrecord",
  id: 1,
  component: () => import("@/page/custom/common/customrecord.vue")
};
/**
 * 商品------------------------------------------
 * */
// 商品管理
export const goodsList = {
  path: "/goodsList",
  name: "goodsList",
  id: 1,
  component: () => import("@/page/goods/goodsList.vue")
};
// 商品类别
export const goodsCategory = {
  path: "/goodsCategory",
  name: "goodsCategory",
  id: 1,
  component: () => import("@/page/goods/goodsCategory.vue")
};
/**
 * 目标------------------------------------------
 * */
// 目标管理-企业目标
export const enterpriseTarget = {
  path: "/enterpriseTarget",
  name: "enterpriseTarget",
  id: 1,
  component: () => import("@/page/target/targetManage/enterpriseTarget.vue")
};
// 团队目标
export const teamTarget = {
  path: "/teamTarget",
  name: "teamTarget",
  id: 1,
  component: () => import("@/page/target/targetManage/teamTarget.vue")
};
// 个人目标
export const personalTarget = {
  path: "/personalTarget",
  name: "personalTarget",
  id: 1,
  component: () => import("@/page/target/targetManage/personalTarget.vue")
};
/**
 * 财务------------------------------------------
 * */
// 财务管理-营收记录
export const revenueRecord = {
  path: "/revenueRecord",
  name: "revenueRecord",
  id: 1,
  component: () => import("@/page/finance/financeManage/revenueRecord.vue")
};
// 支出记录
export const expenseRecord = {
  path: "/expenseRecord",
  name: "expenseRecord",
  id: 1,
  component: () => import("@/page/finance/financeManage/expenseRecord.vue")
};
// 财务统计
export const statistics = {
  path: "/statistics",
  name: "statistics",
  id: 1,
  component: () => import("@/page/finance/financeManage/statistics.vue")
};
/**
 * 课程-----------------------------------------
 * */
// 会员课程
export const vipcourselist = {
  path: "/vipcourselist",
  name: "vipcourselist",
  id: 1,
  component: () => import("@/page/course/memberCourse/vipcourselist.vue")
};
// 陪跑课程
export const comcourselist = {
  path: "/comcourselist",
  name: "comcourselist",
  id: 1,
  component: () => import("@/page/course/commonCourse/comcourselist.vue")
};
/**
 * 系统管理---------------------------------------
 * */
// 菜单管理
export const menumanage = {
  path: "/menumanage",
  name: "menumanage",
  id: 1,
  component: () => import("@/page/system/menuManage/menumanage.vue")
};
// 角色管理
export const rolemanage = {
  path: "/rolemanage",
  name: "rolemanage",
  id: 1,
  component: () => import("@/page/system/roleManage/rolemanage.vue")
};
export const userformrole = {
  path: "/userformrole",
  name: "userformrole",
  id: 1,
  component: () => import("@/page/system/roleManage/userformrole.vue")
};
// 部门管理
export const department = {
  path: "/department",
  name: "department",
  id: 1,
  component: () => import("@/page/system/organization/department.vue")
};
// 用户管理
export const userManage = {
  path: "/userManage",
  name: "userManage",
  id: 1,
  component: () => import("@/page/system/organization/userManage.vue")
};
// 系统日志
export const systemLogs = {
  path: "/systemLogs",
  name: "systemLogs",
  id: 1,
  component: () => import("@/page/system/systemSeting/systemLogs.vue")
};



// WEBPACK FOOTER //
// ./src/router/export.js